import { render } from "./journalManageDetail.vue?vue&type=template&id=a58ba648"
import script from "./journalManageDetail.vue?vue&type=script&lang=js"
export * from "./journalManageDetail.vue?vue&type=script&lang=js"

import "./journalManageDetail.vue?vue&type=style&index=0&id=a58ba648&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__